import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { Row } from '../../../../../components/Row';
import {
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
} from '../../../../../library/ProjectStatus';
import { getStepSlug } from '../../../../../library/ProjectSteps';
import { projectEdit } from '../../../../../library/Routes';
import { openModal } from '../../../../../store/modules/ModalActions';
import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
  removerDocumento,
  saveProjeto,
  uploadDocumento,
} from '../../../../../store/modules/ProjetoActions';
import {
  etapaIsUnlocked,
  getProjectFilesByEtapa,
} from '../../../../../utils/ProjetoUtils';

class Etapa2_2 extends GenericProjectCard {
  stepIndex = 3;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      descricaoExpedicaoChanged: false,
      sending: false,
    };

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
    this.saveUploadChanges = this.saveUploadChanges.bind(this);
    this.mergeFiles = this.mergeFiles.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, this.stepIndex);
  }

  descricaoExpedicaoIsValid() {
    return this.props.projeto.descricaoExpedicao
      ? this.props.projeto.descricaoExpedicao.length > 0
      : false;
  }

  changeSendingStatus(status) {
    this.setState({
      ...this.state,
      sending: status,
    });
  }

  saveUploadChanges() {
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = this.stepIndex;
    avaliacao.status =
      avaliacao.status === PROJECT_STATUS_RASCUNHO
        ? PROJECT_STATUS_RASCUNHO
        : PROJECT_STATUS_PENDENTE;
    let documentos = [];
    this.props.projeto.documentos.map((file, index) => {
      documentos.push({
        principal: file.principal,
        caminho: file.id,
      });
      return index;
    });
    const data = {
      id: this.props.projeto.id,
      idUsuario: this.props.projeto.idUsuario,
      documentos: documentos,
      avaliacao,
    };
    this.props.saveProjeto(data);
  }

  toSubmit() {
    if (!this.itemsAreValid(this.validationResults)) {
      return;
    }
    this.changeSendingStatus(true);
    let avaliacao =
      this.props.projeto.avaliacoes.length > this.stepIndex + 1
        ? this.props.projeto.avaliacoes[this.stepIndex]
        : {};
    avaliacao.etapa = 2;
    avaliacao.status = PROJECT_STATUS_PENDENTE;
    const data = {
      id: this.props.projeto.id || null,
      idUsuario: this.props.projeto.idUsuario,
      descricaoExpedicao: this.props.projeto.descricaoExpedicao,
      consultaPublica: this.props.projeto.consultaPublica,
      avaliacao,
    };
    this.props.saveProjeto(
      data,
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.props.languageValues.successCadastrarEtapa2_2,
          options: {
            variant: 'success',
          },
        });
        this.changeSendingStatus(false);
        this.props.history.push(
          projectEdit.getURLWithParams(
            this.props.projeto.id,
            getStepSlug(this.stepIndex + 1)
          )
        );
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarEtapa2_2,
          options: {
            variant: 'error',
          },
        });
        this.changeSendingStatus(false);
      }
    );
  }

  render() {
    this.validationResults =
      !etapaIsUnlocked(this.stepIndex, this.props.projeto.avaliacoes) ||
      this.state.sending
        ? [false]
        : [this.descricaoExpedicaoIsValid()];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa2_2}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa2_2,
        }}
        sending={this.state.sending}
      >
        <form
          className={this.getFormClasses(this.state.sending)}
          onSubmit={(event) => {
            event.preventDefault();
            this.toSubmit(event);
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoExpedicao}
                name='descricaoExpedicao'
                value={this.props.projeto.descricaoExpedicao || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.descricaoExpedicaoIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              {this.getUploaderButton(
                // ButtonLabel
                this.props.languageValues.uploadLabelButton,
                // Counter
                getProjectFilesByEtapa(
                  this.props.projeto.documentos,
                  this.stepIndex,
                  this.props.projeto.id
                ).length || 0,
                // Disabled
                this.props.lockedAllFields ||
                  this.state.sending ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  ),
                // CustomUploaderProps
                {
                  titleHint: this.props.languageValues.direitoImagemHint,
                  toUpload: this.props.uploadDocumento,
                  toRemove: (caminho) =>
                    new Promise((res, rej) => {
                      this.props.removerDocumento(caminho, res, rej);
                    }),
                  cooperativa: this.props.projeto.codigoCooperativa,
                  etapa: this.stepIndex,
                  idProjeto: this.props.projeto.id,
                  fileList: getProjectFilesByEtapa(
                    this.props.projeto.documentos,
                    this.stepIndex,
                    this.props.projeto.id
                  ),
                  onChanged: (list) => {
                    this.mergeFiles(
                      this.props.projeto.documentos,
                      list,
                      this.stepIndex,
                      this.props.projeto.id
                    );
                    this.saveUploadChanges();
                  },
                },
                this.props.openModal
              )}
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa2_2,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              null,
              this.getFinalyButton(
                this.props.lockedAllFields ||
                  !this.itemsAreValid(this.validationResults),
                this.toSubmit
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadHistoricoAvaliacoes,
      openModal,
      uploadDocumento,
      removerDocumento,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa2_2));
